class WishlistAdd extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()
  }

  setupListeners () {
    super.setupListeners()

    this.handleExternalTrigger = this.handleExternalTrigger.bind(this)
    this.handleClose = this.handleClose.bind(this)

    this.handleListSelect = this.handleListSelect.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleNewListInput = this.handleNewListInput.bind(this)
    this.clearSelectedList = this.clearSelectedList.bind(this)
    this.updateSubmitState = this.updateSubmitState.bind(this)

    this.addToWishlist = this.addToWishlist.bind(this)

    this.checkLoggedIn = this.checkLoggedIn.bind(this)
    this.checkProductIsInWishlist = this.checkProductIsInWishlist.bind(this)
    this.checkVariantIsInWishlist = this.checkVariantIsInWishlist.bind(this)

    this.getExternalWishlistTriggers =
      this.getExternalWishlistTriggers.bind(this)
    this.getExternalWishlistCounts = this.getExternalWishlistCounts.bind(this)
    this.setupWishlistTriggerObserver =
      this.setupWishlistTriggerObserver.bind(this)
    this.queueWishlistRefresh = this.queueWishlistRefresh.bind(this)

    this.listeners.add(document, 'click', this.handleExternalTrigger)

    this.listeners.add(this, 'click', this.handleListSelect)
    this.listeners.add(this.els.submit.element, 'click', this.handleSubmit)
    this.listeners.add(
      this.els.newlist.element,
      'input',
      this.handleNewListInput,
    )

    this.populateProductInfo = this.populateProductInfo.bind(this)
    this.populateLists = this.populateLists.bind(this)

    this.handleVariantChange = this.handleVariantChange.bind(this)
    this.listeners.add(this, 'change', this.handleVariantChange)

    this.listeners.add(
      document,
      'checkIsInWishlist',
      this.checkProductIsInWishlist,
    )

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.WISHLIST.CHECK_WISHLIST,
      this.checkProductIsInWishlist,
    )

    window.BAO.eventBus.addEventListener(
      window.BAO.EVENTS.WISHLIST.CHECK_WISHLIST_VARIANT,
      this.checkVariantIsInWishlist,
    )

    this.setupWishlistTriggerObserver()

    window.SwymCallbacks = window.SwymCallbacks || []
    window.SwymCallbacks.push((swat) => {
      this.checkLoggedIn()
      this.checkProductIsInWishlist()
    })
  }

  checkLoggedIn () {
    if (this.hasAttribute('data-is-customer')) return

    /* eslint-disable no-console */
    window._swat.disconnectShopperContext(
      (onSuccess) => console.log('User cleared'),
      this.wishlistError,
    )
    /* eslint-enable */
  }

  handleClose () {
    this.checkProductIsInWishlist()

    window.drawers.activeDrawerKey = ''
  }

  async handleExternalTrigger (event) {
    const trigger = event.target.closest(
      '[data-wishlist-add-external-el="trigger"]',
    )

    if (!trigger || !window._swat) return

    if (trigger.hasAttribute('data-wishlist-added')) {
      const lid = trigger.dataset.wishlistId

      const product = {
        epi: trigger.dataset.variantId,
        empi: trigger.dataset.productId,
        du: `${window.theme.wishlist.shopUrl}${trigger.dataset.productUrl}`,
      }

      window._swat.deleteFromList(
        lid,
        product,
        () => {
          this.checkProductIsInWishlist()
          window.BAO.dispatchEvent(window.BAO.EVENTS.WISHLIST.LISTS_CHANGED)
        },
        this.wishlistError,
      )
    } else {
      window.drawers.activeDrawerKey = 'drawer-wishlist-add'

      this.setAttribute('data-product-id', trigger.dataset.productId)
      this.setAttribute('data-variant-id', trigger.dataset.variantId)
      this.setAttribute(
        'data-product-url',
        `${window.theme.wishlist.shopUrl}${trigger.dataset.productUrl}`,
      )

      this.populateProductInfo(
        `${trigger.dataset.productUrl}?variant=${trigger.dataset.variantId}`,
      )

      this.clearSelectedList()
      this.els.newlist.element.value = ''
      this.updateSubmitState()

      window._swat.fetchLists({
        callbackFn: this.populateLists,
        errorFn: this.wishlistError,
      })
    }
  }

  handleVariantChange (event) {
    const variantsChange = event.target.closest(
      '[data-wishlist-add-el="variants-select"]',
    )

    if (!variantsChange) return

    this.setAttribute('data-variant-id', variantsChange.value)
  }

  populateProductInfo (variantUrl) {
    return window.BAO.sectionRenderer
      .fetchSingle('wishlist-product-info', variantUrl)
      .then((res) => {
        const newDOM = window.BAO.sectionRenderer.convertToDOM(res)
        const myself = newDOM.querySelector('.shopify-section')

        if (myself) {
          this.els['product-info'].element.innerHTML = myself.innerHTML
        }
      })
      .catch(() => {
        return null
      })
  }

  populateLists (lists) {
    this.els.lists.element.innerHTML = ''
    this.selectedListId = null

    lists.forEach((list) => {
      this.els.lists.element.innerHTML += `
        <button
          type="button"
          class="drw-WishlistAdd_Item"
          data-list-id="${list.lid}"
          data-wishlist-add-el="list"
          aria-pressed="false"
        >
          <span class="drw-WishlistAdd_ListName fz-14_22">
            ${list.lname} (${list.cnt})
          </span>
        </button>
      `
    })

    this.els['lists-header'].element.setAttribute(
      'aria-hidden',
      lists.length === 0,
    )

    this.els.newlist.element.value =
      lists.length === 0 ? window.theme.wishlist.wishlist : ''

    this.updateSubmitState()
  }

  handleListSelect (event) {
    const trigger = event.target.closest('[data-wishlist-add-el="list"]')

    if (!trigger) return

    this.selectedListId = trigger.dataset.listId

    this.els.lists.element
      .querySelectorAll('[data-wishlist-add-el="list"]')
      .forEach((listEl) => {
        listEl.removeAttribute('data-selected')
        listEl.setAttribute('aria-pressed', 'false')
      })

    trigger.setAttribute('data-selected', '')
    trigger.setAttribute('aria-pressed', 'true')

    this.els.newlist.element.value = ''

    this.updateSubmitState()
  }

  handleNewListInput () {
    if (this.els.newlist.element.value.trim() !== '') {
      this.clearSelectedList()
    }

    this.updateSubmitState()
  }

  clearSelectedList () {
    this.selectedListId = null

    if (!this.els.lists?.element) return

    this.els.lists.element
      .querySelectorAll('[data-wishlist-add-el="list"]')
      .forEach((listEl) => {
        listEl.removeAttribute('data-selected')
        listEl.setAttribute('aria-pressed', 'false')
      })
  }

  updateSubmitState () {
    if (!this.els.submit?.element) return

    const hasSelectedList = Boolean(this.selectedListId)
    const hasNewListName = this.els.newlist.element.value.trim() !== ''

    this.els.submit.element.disabled = !hasSelectedList && !hasNewListName
  }

  handleSubmit () {
    const newListName = this.els.newlist.element.value.trim()

    if (newListName !== '') {
      const listConfig = {
        lname: newListName,
      }

      window._swat.createList(
        listConfig,
        (newList) => this.addToWishlist(newList.lid),
        this.wishlistError,
      )

      return
    }

    if (!this.selectedListId) return

    this.addToWishlist(this.selectedListId)
  }

  addToWishlist (lid) {
    const product = {
      epi: parseInt(this.dataset.variantId),
      empi: parseInt(this.dataset.productId),
      du: this.dataset.productUrl,
    }

    window._swat.addToList(
      lid,
      product,
      () => {
        this.handleClose()
        window.BAO.dispatchEvent(window.BAO.EVENTS.WISHLIST.LISTS_CHANGED)
      },
      this.wishlistError,
    )
  }

  getExternalWishlistTriggers () {
    return [
      ...document.querySelectorAll('[data-wishlist-add-external-el="trigger"]'),
    ]
  }

  getExternalWishlistCounts () {
    return [
      ...document.querySelectorAll('[data-wishlist-add-external-el="count"]'),
    ]
  }

  setupWishlistTriggerObserver () {
    if (this.wishlistTriggerObserver) return

    this.wishlistTriggerObserver = new MutationObserver((mutations) => {
      const hasNewWishlistTrigger = mutations.some((mutation) => {
        return [...mutation.addedNodes].some((node) => {
          if (!(node instanceof HTMLElement)) return false

          return (
            node.matches?.('[data-wishlist-add-external-el="trigger"]') ||
            node.querySelector?.('[data-wishlist-add-external-el="trigger"]')
          )
        })
      })

      if (!hasNewWishlistTrigger) return

      this.queueWishlistRefresh()
    })

    this.wishlistTriggerObserver.observe(document.body, {
      childList: true,
      subtree: true,
    })
  }

  queueWishlistRefresh () {
    clearTimeout(this.wishlistRefreshTimeout)

    this.wishlistRefreshTimeout = setTimeout(() => {
      this.checkProductIsInWishlist()
    }, 100)
  }

  checkProductIsInWishlist () {
    if (!window._swat) return

    window._swat.fetchLists({
      callbackFn: (lists) => {
        const productCount = lists.reduce(
          (accumulator, list) => accumulator + list.cnt,
          0,
        )

        this.getExternalWishlistCounts().forEach((countEl) => {
          countEl.setAttribute('data-wishlist-active', productCount !== 0)
        })

        this.getExternalWishlistTriggers().forEach((el) => {
          let matchedVariant

          const matchedWishlist = lists.find((list) =>
            list.listcontents.some((product) => {
              if (product.empi === parseInt(el.dataset.productId)) {
                matchedVariant = product.epi
                return true
              }

              return false
            }),
          )

          if (matchedWishlist) {
            el.setAttribute('data-wishlist-added', '')
            el.setAttribute('data-wishlist-id', matchedWishlist.lid)
            el.setAttribute('data-variant-id', matchedVariant)
          } else {
            el.removeAttribute('data-wishlist-added')
            el.removeAttribute('data-wishlist-id')
          }

          el.setAttribute('data-wishlist-active', '')
        })
      },
      errorFn: this.wishlistError,
    })
  }

  checkVariantIsInWishlist () {
    if (!window._swat) return

    window._swat.fetchLists({
      callbackFn: (lists) => {
        const productCount = lists.reduce(
          (accumulator, list) => accumulator + list.cnt,
          0,
        )

        this.getExternalWishlistCounts().forEach((countEl) => {
          countEl.setAttribute('data-wishlist-active', productCount !== 0)
        })

        this.getExternalWishlistTriggers().forEach((el) => {
          const matchedWishlist = lists.find((list) =>
            list.listcontents.some((product) => {
              if (
                product.empi === parseInt(el.dataset.productId) &&
                product.epi === parseInt(el.dataset.variantId)
              ) {
                return true
              }

              return false
            }),
          )

          if (matchedWishlist) {
            el.setAttribute('data-wishlist-added', '')
            el.setAttribute('data-wishlist-id', matchedWishlist.lid)
          } else {
            el.removeAttribute('data-wishlist-added')
            el.removeAttribute('data-wishlist-id')
          }

          el.setAttribute('data-wishlist-active', '')
        })
      },
      errorFn: this.wishlistError,
    })
  }

  wishlistError (errorMessage) {
    // eslint-disable-next-line
    console.log("Wishlist error", errorMessage);
  }
}

if (!customElements.get('wishlist-add')) {
  customElements.define('wishlist-add', WishlistAdd)
}
